(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('microzeit-banner-video')) {
    customElements.define('microzeit-banner-video', class extends HTMLElement {
      connectedCallback() {
        this.banner = this.closest('.banner');
        this.video = this.querySelector('video');
        this.sound = this.querySelector('.microzeit-banner-click-sound');
        this.image = this.querySelector('.microzeit-banner-click-image');
        this.link = this.banner.querySelector('.banner__full-link');
        if ((!this.video && !this.image) || !this.link) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.active = false;
        this.go = () => {
          if (!this.active) return;
          const destination = this.link.href;
          this.reset();
          window.location.assign(destination);
        };
        this.banner.addEventListener('click', (event) => {
          const link = event.target.closest('a');
          if (!link || link.href !== this.link.href || event.button !== 0 ||
              event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
              link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
          if (window.Shopify?.designMode) { event.preventDefault(); return; }
          if (!this.image && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          if (this.active) { this.go(); return; }
          this.active = true;
          this.trigger = link;
          this.playClickSound();
          if (this.image) {
            const attempt = this.attempt = (this.attempt || 0) + 1;
            this.timer = window.setTimeout(this.go, 12000);
            this.image.decode().then(() => {
              if (!this.active || this.attempt !== attempt) return;
              clearTimeout(this.timer);
              this.positionVideo();
              this.hidden = false;
              this.querySelector('a').focus({ preventScroll: true });
              this.timer = window.setTimeout(this.go, 2000);
            }).catch(() => {
              if (this.active && this.attempt === attempt) this.go();
            });
            return;
          }
          this.video.muted = true;
          this.video.currentTime = 0;
          this.video.loop = false;
          this.timer = window.setTimeout(this.go, 12000);
          const playback = this.video.play();
          if (playback) playback.catch(this.go);
        }, options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) return;
          if (this.active) { event.preventDefault(); this.go(); }
        }, options);
        this.video?.addEventListener('playing', () => {
          if (!this.active) return;
          this.positionVideo();
          this.hidden = false;
          this.querySelector('a').focus({ preventScroll: true });
        }, options);
        this.video?.addEventListener('ended', this.go, options);
        this.video?.addEventListener('error', this.go, options);
        window.addEventListener('resize', () => { if (this.active) this.positionVideo(); }, options);
        window.addEventListener('pagehide', () => this.reset(), options);
        window.addEventListener('pageshow', () => this.reset(), options);
      }
      playClickSound() {
        if (!this.sound) return;
        try {
          this.sound.volume = Math.min(1, Math.max(0, Number(this.sound.dataset.volume) / 100));
          this.sound.currentTime = 0;
          const playback = this.sound.play();
          if (playback) playback.catch(() => {});
        } catch (_) {}
      }
      positionVideo() {
        const media = this.banner.querySelector('.banner__media');
        const mobileBottom = window.matchMedia('(max-width: 749px)').matches &&
          this.banner.classList.contains('banner--mobile-bottom');
        this.style.top = '0';
        this.style.left = '0';
        this.style.width = '100%';
        this.style.height = mobileBottom && media ? media.offsetHeight + 'px' : '100%';
      }
      reset() {
        this.attempt = (this.attempt || 0) + 1;
        clearTimeout(this.timer);
        this.active = false;
        this.hidden = true;
        this.video?.pause();
        this.sound?.pause();
        if (this.contains(document.activeElement)) this.trigger?.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.reset();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
